<template>
    <v-btn color="aqua-teal" max-width="300">
        {{ buttonLabel }}
        <v-menu offset-y activator="parent">
            <v-list>
                <v-list-item @click="setType(item)" v-for="(item, index) in types" :key="index">
                    <v-list-item-title> {{ item }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-btn>
</template>

<script>
export default {
    name: "ProgressChartDropdown",
    data () {
        return {
            type: "",
        }
    },
    mounted() {
        if (this.types.length > 0){
            this.type = (this.currentValue) ? this.currentValue : this.types[0];
            this.setType(this.type);
        } else {
            this.type = ""; 
        }
        
    },
    props: {
        'buttonLabel': String,
        'currentValue': String,
        'types': {
            default: Array()
        }
    },
    emits: ['updateType'],
    methods: {
        setType(value) {
            if (this.type !== value) {
                this.type = value;
                this.$emit("updateType", this.type);
            }
        }
    }
}
</script>